import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from '@panel/commons';
import { withSnackbar } from '@panel/commons/lib/snackbar';
import { useSelector } from 'react-redux';
import { Container, Wrapper, ModuleContainer, Aside, DisabledOverlay } from './styles';
import { SectionsWrapper } from './sections';
import { FeedbackBox } from '../feedbackbox';
import { SavePostingSelectors } from '../../ducks/savePosting';

function Step2Container() {
  const { savedFromModal } = useSelector(SavePostingSelectors.getSavePostingState);
  const [reachedBreakPoint] = useBreakpoint(1280);
  const { t } = useTranslation();
  return (
    <Container data-repa='step2-fotosVideos-container' savedFromModal={savedFromModal}>
      {savedFromModal && <DisabledOverlay />}
      <Wrapper data-repa='step2-fotosVideos-container-wrapper'>
        {reachedBreakPoint && (
          <Aside data-repa='step2-fotosVideos-container-aside'>
            <FeedbackBox data-repa='step2-fotosVideos-container-feedbackBox' />
          </Aside>
        )}
        <ModuleContainer>
          <SectionsWrapper
            back='caracteristicas'
            step='principales'
            title={t('publisher.step2.mainTitle')}
            eventName='Multimedia'
          />
        </ModuleContainer>
      </Wrapper>
    </Container>
  );
}

export default withSnackbar({ fixed: 'true' })(Step2Container);
